<script>
    import { browser } from '$app/environment';

    /* 
        buttons = {[
            {value: "points", html: "Points"},
            {value: "heatmap-points", html: "Heatmap&#xFF0B;Points"},
            {value: "heatmap", html: "Heatmap"},
            {value: "off", html: "Hide", help: "Your visited cities will be visible to you only"},
        ]}
    */

    let {
        id,
        buttons = [],
        form = [],
        onclick
    } = $props();

    if(!id) {
        throw new Error('AddOnButtons: ID must be defined');
    }

    let help = $state('');

    $effect(() => {
        setAddonButtonsState(id, form?.[id]);
    });
    
    function setAddonButtonsState(name, value) {
        help = buttons.find((e) => e.value === value)?.help || '';

        if(!browser) return;

        let elements = document.getElementsByName(name); 
                
        for (let el of elements) {
            if(el.value === value) {
                el.classList.add("is-selected", "is-link");
            } else {
                el.classList.remove("is-selected", "is-link");
            }
        }            

    }
</script>

<div>
    <div class="field has-addons">
        {#each buttons as button}
            <p class="control">
                <button class="button is-small" name={id} value={button.value}
                    onclick={(e) => {
                        e.preventDefault();
                        setAddonButtonsState(e.currentTarget.name, e.currentTarget.value);
                        onclick(e);
                    }}>{@html button.html}</button>
            </p>            
        {/each}
    </div>
    <div id="help" class="help is-text">{@html help}</div> 
</div>
